import RpIcon from "@/components/RpIcon";
import { BUSINESS_TYPE } from "@/constant/Constant";
import RouteConstant from "@/constant/RouteConstant";
import { Box, Stack } from "@mui/material";
import { createSearchParams, useNavigate } from "react-router-dom";
import classes from "../../css/index.module.less";
import dayjs from "dayjs";

export default function DebtList({ list }) {
  const navigate = useNavigate();

  const _onDetail = (record) => {
    if (record.businessType == BUSINESS_TYPE.DEPT_PAYMENT_BUSINESS_TYPE) { // 还清欠款
      navigate({
        pathname: RouteConstant.DEBT_PAYMENT_DETAIL,
        search: createSearchParams({
          'sn': record.oriBusinessSn ?? record.businessSn
        }).toString()
      });
    } else if (record.businessType == BUSINESS_TYPE.DEPT_UN_PAYMENT_BUSINESS_TYPE) { // 未还清欠款
      navigate({
        pathname: RouteConstant.DEBT_UNPAYMENT_DETAIL,
        search: createSearchParams({
          'sn': record.oriBusinessSn ?? record.businessSn
        }).toString()
      });
    }
  }

  const groupedItems = list.reduce((acc, item) => {
    const date = dayjs(item.createTime).format('dddd, MMMM D');
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(item);
    return acc;
  }, {});

  return (
    <>
      {Object.keys(groupedItems).map((date) => (
        <Box key={date}>
          <Box>
            <p className={classes["flow-date"]}>{date}</p>
          </Box>
          {groupedItems[date].map((item, idx) => (
            <Stack className={classes['flow-list']} key={idx} direction={'row'} alignItems="center" justifyContent="space-between" onClick={() => _onDetail(item)}>
              <Stack direction={'row'} alignItems={'center'} gap={'10px'}>
                <Box className={classes['icon-wrap']}><RpIcon icon={'dolloar'} size={16}/></Box>
                <Stack>
                  <div className={'text-primary'}>{item.businessTypeDisplayName}</div>
                  <div>
                    <span className={'tiny'}>...{item.cardLast4}</span> <span className={'tiny'}>{dayjs(item.createTime).format('HH:mm:ss')}</span>
                  </div>
                </Stack>
              </Stack>
              <div>
                <span className={'text-primary'}>{item.amount ?? '.00'}</span> <span className={'span'}>{item.varietyCodeShortName ?? ''}</span>
              </div>
            </Stack>
          ))}
        </Box>
      ))}
    </>
  );
}